import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, chakra } from '@chakra-ui/react';
import { parseRich } from '@src/components/sco/Admin/AiCrm/data/format';
import React from 'react';

/**
 * `**bold**` lifts a phrase, and `{{name}}` shows as a gold fill-in chip, as in the handoff.
 * `lift` is the bold color: the default is plain `fg`, `accent` uses the warm palette.
 */
export function CrmRich(props) {
  const $ = _c(12);
  let rest;
  let t0;
  let text;
  if ($[0] !== props) {
    ({
      lift: t0,
      text,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
    $[3] = text;
  } else {
    rest = $[1];
    t0 = $[2];
    text = $[3];
  }
  const lift = t0 === undefined ? "fg" : t0;
  let t1;
  if ($[4] !== lift || $[5] !== text) {
    let t2;
    if ($[7] !== lift) {
      t2 = (part, index) => {
        if (part.kind === "bold") {
          return <chakra.strong key={index} color={lift === "accent" ? "orange.fg" : "fg"} fontStyle="normal" fontWeight="bold">{part.text}</chakra.strong>;
        }
        if (part.kind === "variable") {
          return <chakra.span key={index} bg="yellow.subtle" borderRadius="sm" color="yellow.fg" fontFamily="mono" fontSize="0.9em" fontWeight="semibold" px={1}>{part.text}</chakra.span>;
        }
        return <React.Fragment key={index}>{part.text}</React.Fragment>;
      };
      $[7] = lift;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = parseRich(text).map(t2);
    $[4] = lift;
    $[5] = text;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[9] !== rest || $[10] !== t1) {
    t2 = <Box as="span" {...rest}>{t1}</Box>;
    $[9] = rest;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}